// dependencies
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useRef, useEffect, useState } from "react";

const refetchIntervalSeconds = 5;

export const useServerMonitor = (healthUrl) => {
	const previousHashes = useRef([]);
	const [isMounted, setIsMounted] = useState(true);

	// teardown function - cleanup when component unmounts
	useEffect(() => {
		return () => {
			setIsMounted(false);
			previousHashes.current = [];
		};
	}, []);

	// fetch the webserver status using the useQuery hook.
	const { data, isLoading } = useQuery({
		queryKey: ["healthStatus", healthUrl],
		queryFn: () => axios.get(healthUrl),
		refetchInterval: 1000 * refetchIntervalSeconds,
		refetchIntervalInBackground: false,
		enabled: isMounted && !!healthUrl,
	});

	// parse the response data.
	const currentHash = data?.data?.gitHash ?? null;
	const currentShortHash = data?.data?.gitHashShort ?? null;
	const currentBranch = data?.data?.gitBranch ?? null;
	const currentHealthy = data?.data?.healthy ?? null;

	// if we don't have a current hash, then we probably are still loading.
	if (isLoading) {
		return { isLoading };
	}

	// update our previousHashes array and we don't want to hold more than
	// 5 hashes.
	previousHashes.current = [...previousHashes.current.slice(-4), currentHash];

	// return our hook response
	return {
		gitHash: currentHash,
		gitHashShort: currentShortHash,
		healthy: currentHealthy,
		gitBranch: currentBranch,
		hashHistory: previousHashes.current,
		healthUrl: healthUrl,
		isLoading,
	};
};
